module.exports = __webpack_public_path__ + "img/4.f0e717d1.png";